import { getClientVersion } from 'owa-actionable-message-analytics';
import { getConnectorsLTIToken } from 'owa-connectors';
import { trace } from 'owa-trace';
import { Theme } from 'owa-actionable-message-v2';
import { getActionEndpointUrlFromStore } from '../selectors/getActionEndpoint';
import { format } from 'owa-localize';

const THEME_SERIVCE_ENDPOINT_FORMAT = '{0}{1}/theme';

export default async function makeDownloadThemeRequest(
    colorScheme: string = 'default'
): Promise<{ [index: string]: Theme }> {
    const token = await getConnectorsLTIToken();
    const requestInit: RequestInit = createRequestInit(token, colorScheme);

    const themeServiceEndpoint = format(
        THEME_SERIVCE_ENDPOINT_FORMAT,
        window.location.origin,
        getActionEndpointUrlFromStore()
    );
    let errorMessage = undefined;
    try {
        const response: Response = await fetch(themeServiceEndpoint, requestInit);

        if (response && response.status == 200 /* OK */) {
            const themes = parseSuccessResponse(await response.text());
            return themes;
        } else if (!response) {
            errorMessage = 'No response';
        } else {
            errorMessage = response.status + '-' + response.statusText;
        }
    } catch (e) {
        errorMessage = e.message;
    }

    throw errorMessage;
}

function parseSuccessResponse(responseText: string): { [index: string]: Theme } {
    const themes: { [index: string]: Theme } = {};
    try {
        const response = JSON.parse(responseText);
        const connectorsThemes: object = response.connectors;
        Object.keys(connectorsThemes).forEach((key: string) => {
            const theme = {
                themeConfigUrl: connectorsThemes[key],
                hostConfig: null,
                stylesheetUrl: null,
                isResolved: false,
            };
            themes[key] = theme;
            //setThemeForKey(key, theme);
        });
    } catch (exception) {
        trace.warn(
            '[ActionableMessageDebug] downloadThemeDefinition: error parsing response: ' + exception
        );
    }

    return themes;
}

function createRequestInit(token: string, colorScheme: string): RequestInit {
    const requestInit: RequestInit = {};
    let clientVersion = getClientVersion();
    clientVersion = clientVersion.replace(/[^\d]/g, '');

    requestInit.method = 'GET';
    requestInit.headers = new Headers();

    // request.open('GET', store.themeStore.serviceEndpoint, true);
    // request.timeout = 5000;
    (<Headers>requestInit.headers).set('X-ClientType', 'owa');
    (<Headers>requestInit.headers).set(
        'X-ClientVersion',
        `16.${clientVersion.substr(0, 4)}.${clientVersion.substr(4, 4)}.${clientVersion.substr(8)}`
    );
    (<Headers>requestInit.headers).set('X-ClientColorScheme', colorScheme);
    (<Headers>requestInit.headers).set('Authorization', `Bearer ${token}`);
    return requestInit;
}
